'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUFFIX = exports.FORM_SUBMIT = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.onSubmitActions = onSubmitActions;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var identity = function identity(f) {
  return f;
};
var FORM_SUBMIT = exports.FORM_SUBMIT = '@@redux-form-submit-saga/FORM_SUBMIT';
var SUFFIX = exports.SUFFIX = ['SUBMIT', 'SUCCESS', 'FAILURE'];

function formSubmit(submitCreator, successActionType, failureActionType, values, resolve, reject) {
  return {
    type: FORM_SUBMIT,
    meta: {
      successActionType: successActionType,
      failureActionType: failureActionType,
      resolve: resolve,
      reject: reject
    },
    payload: submitCreator(values)
  };
}

var creatorFactory = function creatorFactory(type, transform) {
  return function (payload) {
    return {
      type: type,
      payload: transform(payload)
    };
  };
};

function normalizeShortSig(root) {
  var transform = arguments.length <= 1 || arguments[1] === undefined ? identity : arguments[1];

  var types = SUFFIX.map(function (s) {
    return root + '_' + s;
  });
  types[0] = creatorFactory(types[0], transform);
  return types;
}

function normalizeLongSig(submit, success, failure) {
  var transform = arguments.length <= 3 || arguments[3] === undefined ? identity : arguments[3];

  var submitCreator = typeof submit === 'string' ? creatorFactory(submit, transform) : submit;
  return [submitCreator, success, failure];
}

function normalizeActionArray(input) {
  if (!input.length) {
    throw new Error('You must provide action types to onSubmitActions');
  }
  if ((0, _typeof3.default)(input[0]) === 'object') {
    return normalizeLongSig(input[0].submit, input[0].success, input[0].failure);
  }
  if (input.length > 2) {
    // eslint-disable-line no-magic-numbers
    return normalizeLongSig.apply(undefined, (0, _toConsumableArray3.default)(input));
  }
  return normalizeShortSig.apply(undefined, (0, _toConsumableArray3.default)(input));
}

function onSubmitActions() {
  for (var _len = arguments.length, actions = Array(_len), _key = 0; _key < _len; _key++) {
    actions[_key] = arguments[_key];
  }

  var actionArray = normalizeActionArray(actions);
  return function (values, dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch(formSubmit.apply(undefined, (0, _toConsumableArray3.default)(actionArray).concat([values, resolve, reject])));
    });
  };
}